import { useCallback } from "react";

import authApi from "../../../api/public";
import { useDispatch } from "../../../redux/hooks";
import { clearAuth } from "../../../redux/slices/auth/authSlice";



const useLogoutWithoutRedirect = () => {
    const dispatch = useDispatch();

    return useCallback(
        async () => {
            try {
                authApi.logout();
            } catch (e) {
                console.error(e);
            }
            dispatch(clearAuth());
        },
        [dispatch],
    );
};

export default useLogoutWithoutRedirect;
